import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import AdminDashboard from "@/pages/admin/admin-dashboard";
import AdminLogin from "@/pages/admin/admin-login";
import UserDashboard from "@/pages/dashboard/user-dashboard";
import { Home } from "@/pages/home";
import Login from "@/pages/login";
import { NotFound } from "@/pages/not-found";
import { Unauthorized } from "@/pages/unauthorized";
import { Providers } from "@/providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/dashboard" element={<UserDashboard />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
